import http from '@/plugins/http';
import reportError from '@/utils/reportError';
import studentDetailTransformer from '../../transformers/students/studentDetail';

// When the request succeeds
const success = (response, successCallback) => {
  response = studentDetailTransformer.fetch(response);
  successCallback(response);
};

// When the request fails
const failed = () => {
};

export default (studentId, successCallback) => {
  http.get(`v3/students/${studentId}/detail`)
    .then((response) => {
      success(response.data, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error when trying to get user detail');
      failed(error);
    });
};
